import React, { useContext, useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { AppContexts } from "../../../providers";
import surveysService from "../../../services/surveys.service";
import SurveyPreviewForm from "../SurveyPreviewForm";

const SurveyPreview = () => {
  const { get, settings } = useContext(AppContexts.SettingsContext);
  const history = useHistory();
  const getBranding = useRef(get);
  const surveyId = history.location.pathname.split("/")[2];
  const [survey, setSurvey] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    document.title = "Preview Survey - RueBaRue";
    const navbar = document.getElementById("ruebarue-navbar");
    const wasHidden = navbar?.hidden;
    if (navbar) navbar.hidden = true;
    getBranding.current(["branding"]);
    setSurvey(null); setError("");
    surveysService.getSurveyById(surveyId).then(({ data }) => {
      if (active) data ? setSurvey(data) : setError("Survey not found.");
    }).catch(() => { if (active) setError("Unable to load the survey. Please reload and try again."); });
    return () => { active = false; if (navbar) navbar.hidden = wasHidden; };
  }, [surveyId]);
  return <div id="surveys-preview-template">
    {settings.branding?.logo_image_url && <div className="hms-logo"><a href={settings.branding?.logo_url} target="_blank" rel="noreferrer" className="hms-logo-url"><img src={settings.branding.logo_image_url} alt="Company logo" /></a></div>}
    {error ? <p role="alert" className="uk-text-danger">{error}</p> : !survey ? <p role="status">Loading survey…</p> : <>
      <div id="hms-page-title"><h1 className="uk-heading-small">{survey.name}</h1>{survey.intro && <p style={{ whiteSpace: "pre-wrap" }}>{survey.intro}</p>}</div>
      <div id="hms-main-body"><SurveyPreviewForm key={surveyId} survey={survey} /></div>
    </>}
  </div>;
};
export default SurveyPreview;
